import NAME from "./constants";

export const getIsLoading = store => store[NAME].isLoading;
export const getData = store => store[NAME].data;
export const getSchedules = store => store[NAME].schedules;
export const getOpenCalendar = store => store[NAME].openCalendar;
export const getMinDates = store => store[NAME].minDates;
export const getWeeklyHours = store => store[NAME].weeklyHours;
